import * as React from "react";
import { Alert, AlertTitle, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";
import DetailPage, { DetailPageTab } from "../../../components/common/detailPage/detailPage";
import { SimpleBreadcrumbs } from "../../../components/navigation/simpleBreadcrumbs";
import StandardLayout from "../../../layouts/standard";
import Notes from "../payrollTabs/Misc Work/notes";
import Summary from "../payrollTabs/Misc Work/summary";
import TrainerDetails from "../payrollTabs/Misc Work/trainerDetails";
import WorkEntries from "../payrollTabs/Misc Work/workEntries";
import { getMiscWorkRecordById } from "../payrollTabs/miscWorkData";

export type MiscWorkDetailsRouteParams = {
    miscWorkId: string;
};

const MiscWorkDetails: React.FC = () => {
    const params = useParams<MiscWorkDetailsRouteParams>();
    const miscWorkId = params.miscWorkId ?? "";
    const record = getMiscWorkRecordById(miscWorkId);

    const breadcrumbs = (
        <Stack direction="row" spacing={3}>
            <SimpleBreadcrumbs>
                <Typography variant="h6" color="text.primary">
                    <Link key="payrollLink" component={RouterLink} to="/payroll">
                        Payroll
                    </Link>
                </Typography>
                <Typography variant="h6" color="text.primary">
                    {record?.projectCode ?? "Misc. Work Details"}
                </Typography>
            </SimpleBreadcrumbs>
        </Stack>
    );

    if (!record) {
        return (
            <StandardLayout breadcrumbs={breadcrumbs}>
                <Alert severity="error" sx={{ fontSize: 14 }}>
                    <AlertTitle sx={{ fontSize: 14 }}>Error</AlertTitle>
                    Misc. work record was not found.
                </Alert>
            </StandardLayout>
        );
    }

    const tablist: DetailPageTab[] = [
        {
            label: "Summary",
            index: 0,
            content: <Summary record={record} />,
        },
        {
            label: "Work Entries",
            index: 1,
            content: <WorkEntries record={record} />,
        },
        {
            label: "Trainer Details",
            index: 2,
            content: <TrainerDetails record={record} />,
        },
        {
            label: "Notes",
            index: 3,
            content: <Notes record={record} />,
        },
    ];

    return (
        <DetailPage
            tablist={tablist}
            breadcrumbs={breadcrumbs}
            descriptor="misc-work"
            identifier={record.id.toString()}
        />
    );
};

export default MiscWorkDetails;